import { get, request } from '@insite/client-framework/Services/ApiService';

export interface CoveoToken {
    token: string;
    coveoOrgId: string;
    commerceView: string;
    trackingId: string;
    language: string;
    country: string;
    currency: string;
}

export interface CoveoProductListingRequest {
    trackingId: string;
    clientId: string;
    context: {
        view: {
            url: string;
        };
    };
    page: number;
    language: string;
    country: string;
    currency: string;
}

export interface CoveoProduct {
    additionalFields: Record<string, string>;
    children: CoveoProduct[];
    clickUri: string;
    ec_brand: string;
    ec_category: string[];
    ec_color: string;
    ec_description: string;
    ec_gender: string;
    ec_images: string[];
    ec_in_stock: boolean;
    ec_item_group_id: string;
    ec_listing: string;
    ec_name: string;
    ec_price: number;
    ec_product_id: string;
    ec_promo_price: number;
    ec_rating: number;
    ec_shortdesc: string;
    ec_thumbnails: string[];
    permanentid: string;
    totalNumberOfChildren: number;
}

export interface CoveoProductListResponse {
    responseId: string;
    products: CoveoProduct[];
    pagination: {
        page: number;
        perPage: number;
        totalEntries: number;
    }
}

const coveoTokenUrl = "/api/v2/coveotoken";
export async function getCoveoToken() {
    return await get<CoveoToken>(coveoTokenUrl);
}

export async function getCoveoProductListing(url: string, token: string, requestData: CoveoProductListingRequest) {
    const response = await request<CoveoProductListResponse>(
        url,
        "POST",
        {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
        },
        JSON.stringify(requestData),
    );

    return response;
}
